import { ApolloClient } from '@apollo/client';
import { GET_SITE_TRADE_SUMMARY, GET_SITES } from 'pages/Optimisation/queries';
import { ApiName } from 'types/apiName';
import { endOfTradingDay, startOfTradingDay } from 'utils/optimisation';

export const prefetchSites = async ({
  client,
  companyId,
  currentDate,
}: {
  client: ApolloClient;
  companyId: string;
  currentDate: Date;
}) => {
  try {
    const response = await client.query({
      query: GET_SITES,
      variables: { filter: { company: { id: { eq: companyId } } } },
      fetchPolicy: 'cache-first',
      context: {
        apiName: ApiName.plutoApi,
      },
    });

    const { data, error } = response;

    if (data && (data as any).sites?.edges[0]) {
      await client.query({
        query: GET_SITE_TRADE_SUMMARY,
        variables: {
          siteId: (data as any).sites.edges[0].node.id,
          start: startOfTradingDay(currentDate),
          end: endOfTradingDay(currentDate),
        },
        fetchPolicy: 'cache-first',
        context: {
          apiName: ApiName.plutoApi,
        },
      });
    }

    return { data, loading: false, error };
  } catch (error) {
    return { data: null, loading: false, error };
  }
};
